import {routes} from './servico.routes';
import ServicoListController from "./directory/directory.controller";
import ServicoService from "./servico.service";
import ServicoDetailsController from "./details/details.controller";
import ServicoCreateServicoController from "./new/new.controller";

export default angular.module('app.servico', [])
  .config(routes)
  .controller('ServicoListController', ServicoListController)
  .service('ServicoService', ServicoService)
  .controller('ServicoDetailsController', ServicoDetailsController)
  .controller('ServicoCreateServicoController', ServicoCreateServicoController)
  .name;
